// extracted by mini-css-extract-plugin
export default {"container":"jq-z"};